import React from 'react';
import {Tag} from 'antd';
import {PreviewButton} from '../PreviewButton';
import {DownloadButton} from '../DownloadButton';
import {FileThumbnail} from '../FileThumbnail';

interface SearchResultItemProps {
  item: any;
  onJumpPath: (file: any) => void;
}

export function SearchResultItem({item, onJumpPath}: SearchResultItemProps) {
  // 安全渲染高亮文本：移除潜在危险标签，仅保留<span class='highlight'>
  function safeHtml(html: string) {
    if (!html) return '';
    // 仅允许 <span class="highlight"> 标签，移除其他HTML标签
    return html.replace(/<(?!\/?(span|highlight)[^>]*>)[^>]+>/gi, '');
  }

  // 区分AI标签和自定义标签
  const customTags = item.custom_tags || [];
  const aiTags = item.tags || [];
  const allTags: Array<{ name: string; type: 'custom' | 'ai' }> = [
    ...customTags.map((t: string) => ({name: t, type: 'custom' as const})),
    ...aiTags.map((t: string) => ({name: t, type: 'ai' as const})),
  ];

  return (
    <div className="drive-search-result-item">
      <FileThumbnail file={item}/>

      <div className="drive-search-result-item__main">
        <div className="drive-search-result-item__tags">
          {allTags.map(({name, type}, idx) => (
            <Tag
              key={`${name}-${idx}`}
              color={type === 'custom' ? 'green' : 'blue'}
              className={type === 'custom' ? 'drive-search-result-item__tag--custom' : 'drive-search-result-item__tag'}
            >
              {name}
            </Tag>
          ))}
        </div>

        <div>
          <PreviewButton file={item}>
            <div
              className="drive-search-result-item__name drive-search-result-item__preview-trigger"
              dangerouslySetInnerHTML={{__html: safeHtml(item.file_name)}}
            />
          </PreviewButton>

          {item.shared_directory_ids?.length > 0 && (
            <Tag className="drive-search-result-item__shared-tag">来自共享</Tag>
          )}
        </div>

        {item.description && (
          <div
            className="drive-search-result-item__desc"
            dangerouslySetInnerHTML={{__html: safeHtml(item.description)}}
          />
        )}

        {item.full_path && (!item.shared_directory_ids || item.shared_directory_ids.length === 0) && (
          <>
            <span role="img" aria-label="folder" className="drive-search-result-item__path-icon">📂</span>
            <span
              className="drive-search-result-item__path"
              onClick={() => onJumpPath(item)}
            >
              {item.full_path}
            </span>
          </>
        )}
      </div>

      <div className="drive-search-result-item__actions">
        <span style={{marginLeft: 8}}>
          <DownloadButton file={item}/>
        </span>
      </div>
    </div>
  );
}